export const validate = (values) => {
  const errors = {};
  if (!values.code) {
    errors.code = { _error: 'Kode wilayah harus diisi' };
  } else {
    // Remove dots before validation
    const codeWithoutDots = values.code.replace(/\./g, '');

    if (!/^\d+$/.test(codeWithoutDots)) {
      errors.code = { _error: 'Kode wilayah harus berupa angka' };
    } else if (codeWithoutDots.length < 6) {
      errors.code = { _error: 'Kode wilayah minimal 6 digit' };
    } else if (codeWithoutDots.length > 6) {
      errors.code = { _error: 'Kode wilayah maksimal 6 digit' };
    } else if (codeWithoutDots[0] === '0' || codeWithoutDots[1] === '0') {
      errors.code = { _error: 'Kode Wilayah Tidak Valid' };
    }
  }

  if (!values.name) {
    errors.name = { _error: 'Nama wilayah harus diisi' };
  }

  return errors;
};
